export const citationGeneratorBodyWrapperCss = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center" as const,
  justifyContent: "start" as const,
  position: "relative" as const,
  padding: 0,
  margin: 0,
  gap: 10,
  width: "800px",
  height: "auto",
  boxSizing: "border-box" as const,
};
